module.exports = __webpack_public_path__ + "img/img (10).c9125113.jpg";